import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";

export class UtcToLocaleStringValueConverter implements IParameterizedValueConverter<string, Date, string> {
    public toView(value: Date, parameter: string): string {
        if (value === null) {
            return null;
        }
        const utcDate = new Date(value);

        // get the local time zone offset in minutes
        const offsetMinutes = new Date().getTimezoneOffset();

        // convert the UTC time to local time by adding the offset
        const localDate = new Date(utcDate.getTime() - offsetMinutes * 60 * 1000);

        // format the local date as a string
        return localDate.toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false });
    }

    public fromView(value: string, parameter: string): Date {
        throw new NotSupportedError(
            "Converting a string to a date is not yet supported in the DateToStringValueConverter."
        );
    }
}
